module.exports = __webpack_public_path__ + "static/img/img2.b3ce91e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2.png
// module id = xx0f
// module chunks = 1